import apiClient from './apiClient';

/**
 * Sends a contact form message to the admin.
 * The backend applies IP-based rate limiting (3 per hour).
 *
 * @param {{ name: string, email: string, subject: string, message: string }} payload
 * @returns {Promise<{ success: boolean }>}
 */
export const sendContactMessage = async (payload) => {
  const response = await apiClient.post('/contact/', payload);
  return response.data;
};
